import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import LoginPage from '../pages/LoginPage/LoginPage'
import DashboardMain from '../pages/DashboardPage/DashboardPage'
import RegistrationPage from '../pages/SchoolRegistration/RegistrationPage'
import Report from '../containers/Dashboard/components/Pages/Fees/components/FeeReport'
import CreditPage from '../pages/CreditPage/CreditPage'
import StudentFormPage from '../pages/StudentFormPage/StudentFormPage'
import IndividualStudent from '../containers/Dashboard/components/Pages/Student/IndividualStudent/IndividualStudent'
// import LandingPage from '../containers/LandingPage/LandingPage'

const AllRoutes = () => {
  const isAuthenticated = useSelector((state) => state.global.isAuthenticated)

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" replace />}
        />

        {/* <Route
          path="/login"
          element={
            !isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" replace />
          }
        /> */}

        <Route
          path="/dashboard"
          element={isAuthenticated ? <DashboardMain /> : <Navigate to="/login" replace />}
        />

        <Route path="/registration" element={<RegistrationPage />} />
        <Route path="/report" element={<Report />} />
        <Route path="/credits" element={<CreditPage />} />
        <Route path="/student-onboarding" element={<StudentFormPage />} />
        {/* <Route path="/individual-student" element={<IndividualStudent />} /> */}

        {/* Redirect any unknown route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default AllRoutes
